module.exports = __webpack_public_path__ + "static/media/claro_controle_39e90.a22a55ef.png";